module.exports = __webpack_public_path__ + "static/media/sapps.ea2374fc.png";